import blogManifest from "./blogs/blogManifest.json";

function formatPublishedDate(value, language) {
  return new Intl.DateTimeFormat(language === "es" ? "es-CO" : "en-US", {
    day: "numeric",
    month: "short",
    timeZone: "UTC",
    year: "numeric",
  })
    .format(new Date(`${value}T00:00:00Z`))
    .replaceAll(".", "")
    .toUpperCase();
}

function createCatalog(language) {
  const spanish = language === "es";
  return blogManifest.map((metadata) => ({
    id: metadata.slug,
    pillarId: metadata.pillarId,
    angleId: metadata.angleId,
    href: metadata.path,
    title: spanish ? metadata.title : metadata.titleEn,
    description: spanish ? metadata.description : metadata.descriptionEn,
    category: spanish ? metadata.category : metadata.categoryEn,
    publishedAt: metadata.publishedAt,
    publishedLabel: formatPublishedDate(metadata.publishedAt, language),
    readingTime: spanish ? metadata.readingTime : metadata.readingTimeEn,
  }));
}

export const BLOG_CATALOG = {
  es: createCatalog("es"),
  en: createCatalog("en"),
};
